import React from "react";
import { Link } from "react-router-dom";
import { Mail, MessageSquare, Gift } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { RsvpCountdown } from "../components/RsvpCountdown";

export default function RSVP() {
  return (
    <div data-testid="rsvp-page">
      <PageHero overline="Kindly Respond" title="RSVP" subtitle="Please respond by October 15, 2026." />
      <div className="max-w-2xl mx-auto px-5 sm:px-8 py-20">
        <div className="text-center mb-4 bg-olive text-soft-white rounded-lg py-4 px-6 overline" data-testid="rsvp-deadline">
          Please respond by October 15, 2026
        </div>
        <RsvpCountdown />
        <p className="text-center text-taupe text-sm mb-10" data-testid="rsvp-invite-only">
          This is an invitation-only celebration. We have a very limited guest list and can only accommodate the people listed on the invite.
        </p>

        <Reveal>
          <div className="stone-panel border border-taupe/40 rounded-lg p-10 sm:p-14 text-center">
            <div className="flex justify-center gap-4 mb-2">
              <Mail className="text-olive" size={26} />
              <MessageSquare className="text-olive" size={26} />
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl mt-4 text-matte">Respond Through Your Invitation</h2>
            <p className="mt-5 text-taupe text-lg max-w-lg mx-auto">
              You were sent an invitation via text message from <strong className="text-olive">888-959-0613</strong>, or you can search <strong className="text-olive">"Bivins Wedding"</strong> in your text messages. Locate that text message to RSVP.
            </p>
          </div>
        </Reveal>

        {/* registry reminder */}
        <Reveal>
          <div className="mt-8 bg-olive text-soft-white rounded-lg p-8 text-center">
            <Gift className="mx-auto text-gold" size={24} />
            <p className="mt-3 text-soft-white/85">We are kindly requesting contributions to our HoneyFund in lieu of physical gifts.</p>
            <Link to="/registry" className="inline-flex items-center gap-2 mt-4 overline text-gold hover:gap-3 transition-all" data-testid="rsvp-registry-link">
              View Registry
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
